import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { marketingSectionSx, marketingPrimaryButtonSx } from '../components/homepage/marketingSystem';

/** Real 404 — unknown URLs used to silently render the homepage at 200,
 *  which broke old deck links invisibly and confused crawlers. */
const NotFoundPage = () => (
  <Box sx={{ ...marketingSectionSx, minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
    <Container maxWidth="sm">
      <Stack spacing={2.5} alignItems="flex-start">
        <Typography variant="overline" sx={{ letterSpacing: '0.12em', color: '#64748b' }}>
          404 — Not found
        </Typography>
        <Typography variant="h2" component="h1">
          That page isn&apos;t here.
        </Typography>
        <Typography sx={{ color: '#475569' }}>
          The link may be old — the site has moved around. The platform story,
          the pilots, and the papers are all one click away.
        </Typography>
        <Stack direction="row" spacing={1.5}>
          <Button component={RouterLink} to="/" sx={marketingPrimaryButtonSx}>
            Back to the homepage
          </Button>
          <Button component={RouterLink} to="/how-it-works" variant="text">
            How it works
          </Button>
        </Stack>
      </Stack>
    </Container>
  </Box>
);

export default NotFoundPage;
